<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplate]="enviarTemplateEdit" [modulo]="'Balanza'" [tituloCard]="'Reporte de Compras - QM'"
    [titulo]="'Reporte de Balanza Compras - QM'">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplateEdit>
    <section class="section">
      <form [formGroup]="agregarForm" class="form-group" novalidate>
        <div class="row">
          <div class="form-group col-md-3">
            <app-lfsa-combo-box [comboBox]="cmbTipoPedido" [control]="agregarForm.get('tipoPedido') | formControl"
              [idOpcion]="'id'" [id]="'tipoPedido'" [label]="'Tipo Pedido*'" [opcion]="'descripcion'"
              formControlName="tipoPedido" (change)="onChangeTipo();" (keyup)="onChangeTipo();" >
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-combo-box [comboBox]="tiposDeOrdenesDeBalanza" [control]="agregarForm.get('tipoOrden') | formControl"
              [idOpcion]="'id'" [id]="'tipoOrden'" [label]="'Tipo Orden Balanza*'" [opcion]="'desca'"
              formControlName="tipoOrden">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('cliente') | formControl" [id]="'cliente'" [isReadOnly]="false"
              [label]="'Cliente'" [mostrarImg]="false" [placeholder]="'Cliente'" [rutaImagen]="" [type]="'text'"
              formControlName="cliente">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('proveedor') | formControl" [id]="'proveedor'" [isReadOnly]="false"
              [label]="'Proveedor'" [mostrarImg]="false" [placeholder]="'Proveedor'" [rutaImagen]="" [type]="'text'"
              formControlName="proveedor">
            </app-lfsa-input>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('material') | formControl" [id]="'material'" [isReadOnly]="false"
              [label]="'Material'" [mostrarImg]="false" [placeholder]="'Material'" [rutaImagen]="" [type]="'text'"
              formControlName="material">
            </app-lfsa-input>
          </div>
        
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('idOrden') | formControl" [id]="'idOrden'" [isReadOnly]="false"
              [label]="'Ticket Balanza'" [mostrarImg]="false" [placeholder]="'Ticket Balanza'" [rutaImagen]="" [type]="'number'"
              formControlName="idOrden">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('fechaIngreso') | formControl" [id]="'fechaIngreso'" [label]="'Fecha Iinicio'"
              [mostrarImg]="false" [placeholder]="'fechaIngreso'" [rutaImagen]="" [type]="'date'" formControlName="fechaIngreso">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('fechaFin') | formControl" [id]="'fechaFin'" [label]="'Fecha Fin'"
              [mostrarImg]="false" [placeholder]="'fechaFin'" [rutaImagen]="" [type]="'date'" formControlName="fechaFin">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-3">
            <app-lfsa-input [control]="agregarForm.get('pesoTotal') | formControl" [id]="'pesoTotal'" [isReadOnly]="true"
              [label]="'Peso Total Orden (KG.)'" [mostrarImg]="false" [placeholder]="'Peso Total'" [rutaImagen]=""
              [type]="'text'" formControlName="pesoTotal">
            </app-lfsa-input>
          </div>
        </div>
        <div class="row mb-4">
          <div class="form-group col-md-3 d-flex align-items-center"></div>
          <div class="form-group col-md-3 d-flex align-items-center"></div>
          <div class="form-group col-md-3 d-flex align-items-center">
            <button (click)="buscarReporte()" class="btn btn-success btn-block">Buscar</button>
          </div>
          <div class="form-group col-md-3 d-flex align-items-center">
            <button (click)="descargarExcel()" class="btn btn-success btn-block">Descargar Excel
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class"
            [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
            [id]="DAT_AG_GRID.id" [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
            [pagination]="true" [rowData]="rowData">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>